/**
 * Format money string
 * @param number
 * @param isNumberInCents
 * @param precision
 * @param thousands
 * @param decimal
 * @returns {string}
 */
export const formatMoney = (
  number,
  isNumberInCents = false,
  precision = 2,
  thousands = ',',
  decimal = '.'
) => {
  if (isNaN(number) || number == null) {
    return '-';
  }

  const price = (isNumberInCents ? number / 100.0 : number).toFixed(precision);

  const parts = price.split('.');
  const dollars = parts[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${thousands}`
  );
  const cents = parts[1] ? decimal + parts[1] : '';

  return `$${dollars}${cents}`;
};

/**
 * Get money string considering if price varies
 * @param price
 * @param priceVaries
 * @param showZeroPrice
 * @returns {string}
 */
export const getPriceString = (price, priceVaries, showZeroPrice) => (
  /* eslint-disable-next-line no-nested-ternary */
  !showZeroPrice && (price === '0.00' || price === '0' || !price)
    ? '-'
    : priceVaries
      ? `From ${formatMoney(Number(price))}`
      : formatMoney(Number(price))
);

/**
 * Get Sale Percentage
 * @param price
 * @param compareAtPrice
 * @returns {number}
 */
export const getSalePercentage = (price, compareAtPrice) => {
  const sale = Number(price);
  const original = Number(compareAtPrice);
  return sale && original ? ((original - sale) / original * 100).toFixed() : 0;
};
